export default "__VITE_ASSET__B9XIBA5E__"